import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { history } from "src/services/history";
import { NotificationService } from "src/helpers/notifications";
import { getItemPath } from "src/utils/getItemPath";
import {
  successfulResponsesTrns,
  errorResponsesTrns
} from "src/translate/responses";
import { PATHNAMES } from "src/constants/routes";
import { IDeal, Statuses } from "src/@types/deals";

export const CURRENT_DEAL_SLICE_NAME = "currentDeal";

export const getCurrentDealAsync = createAsyncThunk(
  `${CURRENT_DEAL_SLICE_NAME}/fetchCurrentDeal`,
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IDeal>(`/deals/${id}/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      history.push(PATHNAMES.NOT_FOUND, { replace: true });

      NotificationService.error(errorText || errorResponsesTrns.default);

      return rejectWithValue(errorText);
    }
  }
);

export const createDealFromCloneAsync = createAsyncThunk(
  `${CURRENT_DEAL_SLICE_NAME}/fetchCreateDealFromClone`,
  async (id: number, { rejectWithValue }
  ) => {
    try {
      const { data } = await instance.post<IDeal>(
        "/deals/",
        { clone: id }
      );

      history.push(getItemPath(PATHNAMES.DEAL_ITEM, { deal: data.id }), { replace: true });

      NotificationService.success(successfulResponsesTrns.createDeal);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.createDeal);

      return rejectWithValue(errorText);
    }
  }
);

export const createDealFromInquiryAsync = createAsyncThunk(
  `${CURRENT_DEAL_SLICE_NAME}/fetchCreateDealFromInquiry`,
  async (id: number, { rejectWithValue }
  ) => {
    try {
      const { data } = await instance.post<IDeal>(
        "/deals/",
        { inquiry: id }
      );

      history.push(getItemPath(PATHNAMES.DEAL_ITEM, { deal: data.id }), { replace: true });

      NotificationService.success(successfulResponsesTrns.createDeal);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.createDeal);

      return rejectWithValue(errorText);
    }
  }
);


export const deleteDealAsync = createAsyncThunk(
  `${CURRENT_DEAL_SLICE_NAME}/fetchDeleteDeal`,
  async (id: number, { rejectWithValue }
  ) => {
    try {
      const { data } = await instance.delete(
        `/deals/${id}/`,
      );

      history.push(PATHNAMES.DEALS, { replace: true });

      NotificationService.success(successfulResponsesTrns.deleteDeal);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.deleteDeal);

      return rejectWithValue(errorText);
    }
  }
);

export const inProgressDealAsync = createAsyncThunk(
  `${CURRENT_DEAL_SLICE_NAME}/fetchInProgressDeal`,
  async (id: number, { rejectWithValue }
  ) => {
    try {
      const { data } = await instance.patch(
        `/deals/${id}/`,
        { status: Statuses.IN_PROGRESS }
      );

      NotificationService.success(successfulResponsesTrns.inProgressDeal);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.inProgressDeal);

      return rejectWithValue(errorText);
    }
  }
);

export const cancelDealAsync = createAsyncThunk(
  `${CURRENT_DEAL_SLICE_NAME}/fetchCancelDeal`,
  async (id: number, { rejectWithValue }
  ) => {
    try {
      const { data } = await instance.patch(
        `/deals/${id}/`,
        { status: Statuses.CANCELED }
      );

      history.push(PATHNAMES.DEALS, { replace: true });

      NotificationService.success(successfulResponsesTrns.cancelDeal);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.cancelDeal);

      return rejectWithValue(errorText);
    }
  }
);

export const doneDealAsync = createAsyncThunk(
  `${CURRENT_DEAL_SLICE_NAME}/fetchDoneDeal`,
  async (id: number, { rejectWithValue }
  ) => {
    try {
      const { data } = await instance.patch(
        `/deals/${id}/`,
        { status: Statuses.DONE }
      );

      history.push(PATHNAMES.DEALS, { replace: true });

      NotificationService.success(successfulResponsesTrns.doneDeal);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.doneDeal);

      return rejectWithValue(errorText);
    }
  }
);
